import { render } from "./Atencion_Referencia.vue?vue&type=template&id=90f48f38&scoped=true"
import script from "./Atencion_Referencia.vue?vue&type=script&lang=js"
export * from "./Atencion_Referencia.vue?vue&type=script&lang=js"

import "@/assets/css/microfono.css?vue&type=style&index=0&id=90f48f38&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=90f48f38&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f48f38"]])

export default __exports__